module.exports = {
      id: "icon-home-plus-usage",
      viewBox: "0 0 27.193 24.672",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-home-plus",
      toString: function () {
        return this.url;
      }
    }